export default __webpack_public_path__ + "static/images/d4a5f7e06cc9a4fefc25b21bb55425a6.png";